export const IconLogoDou: {
  name: 'icon_logo_dou-a02283a36747'
} = {
  name: 'icon_logo_dou-a02283a36747'
}
